export default "__VITE_ASSET__BjhJDZHx__"